import { useFadeInUp } from '@/hooks/use-fade-in-up'
import Lenis from 'lenis'
import { type ReactNode, createContext, useContext, useEffect, useState } from 'react'

export const LenisContext = createContext<Lenis | null>(null)

export function useLenis(): Lenis | null {
  return useContext(LenisContext)
}

export function LenisProvider({ children }: { children: ReactNode }) {
  useFadeInUp()
  const [lenis, setLenis] = useState<Lenis | null>(null)

  useEffect(() => {
    const instance = new Lenis()
    setLenis(instance)

    let raf: number
    function update(time: number) {
      instance.raf(time)
      raf = requestAnimationFrame(update)
    }
    raf = requestAnimationFrame(update)

    return () => {
      cancelAnimationFrame(raf)
      instance.destroy()
      setLenis(null)
    }
  }, [])

  return <LenisContext.Provider value={lenis}>{children}</LenisContext.Provider>
}
